module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/search/search.component.scss
// module id = ./src/app/components/search/search.component.scss
// module chunks = main